const hideAlertStopQuiz = (state) => {
  return {
    ...state,
    alertStopQuiz: false,
    alertStatus: null,
  }
}

export default hideAlertStopQuiz